const EXCEPTIONS = {
    zh_TW: { lang: 'zh-TW', region: 'TW' },
    he_IL: { lang: 'iw', region: 'IL' }
};

// Accepts either a locale object { canonical: 'en_US' } or a plain canonical string 'en_US'
export const getConfigFromLocale = (locale) => {
    const canonical = typeof locale === 'string' ? locale : locale.canonical;
    if (EXCEPTIONS[canonical]) return EXCEPTIONS[canonical];
    return {
        lang: canonical.substring(0, 2),
        region: canonical.substring(3)
    };
};

export default getConfigFromLocale;
